import { Link } from 'react-router-dom';
import { categories, type CaseItem } from '@/mocks/cases';
import { EvidenceTag } from './EvidenceTag';

const statusStyle: Record<CaseItem['status'], string> = {
  已核实: 'bg-primary-100 text-primary-700',
  待回应: 'bg-accent-100 text-accent-900',
  审核中: 'bg-secondary-100 text-secondary-800',
};

export default function CaseCard({ item, layout = 'vertical' }: { item: CaseItem; layout?: 'vertical' | 'horizontal' }) {
  const category = categories.find((cat) => cat.id === item.categoryId);
  const isHorizontal = layout === 'horizontal';

  return (
    <article
      className={`group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${
        isHorizontal ? 'flex flex-col sm:flex-row' : 'flex flex-col'
      }`}
    >
      <Link
        to={`/case/${item.slug}`}
        className={`relative block shrink-0 overflow-hidden bg-background-200 ${
          isHorizontal ? 'h-48 w-full sm:h-auto sm:w-64' : 'h-48 w-full'
        }`}
      >
        <img
          src={item.cover}
          alt={item.coverAlt}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-foreground-950/80 px-2 py-1 text-xs text-background-50">
          {category?.name}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="mb-2 flex flex-wrap items-center gap-2">
          <span className={`rounded-md px-2 py-1 text-xs ${statusStyle[item.status]}`}>
            <i className="ri-checkbox-circle-line mr-1"></i>
            {item.status}
          </span>
          {item.evidence.slice(0, 3).map((type) => (
            <EvidenceTag key={type} type={type} />
          ))}
        </div>

        <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/case/${item.slug}`} className="hover:text-primary-600">
            {item.title}
          </Link>
        </h3>

        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>

        <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {item.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {item.publishDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {item.views}
          </span>
        </div>
      </div>
    </article>
  );
}